import React from 'react';
import { clsx } from 'clsx';

interface TextProps extends React.HTMLAttributes<HTMLParagraphElement> {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  className?: string;
  children: React.ReactNode;
}

const variantStyles = {
  h1: 'text-4xl font-bold text-gray-900 dark:text-white',
  h2: 'text-3xl font-bold text-gray-900 dark:text-white',
  h3: 'text-2xl font-bold text-gray-900 dark:text-white',
  h4: 'text-xl font-bold text-gray-900 dark:text-white',
  h5: 'text-lg font-bold text-gray-900 dark:text-white',
  h6: 'text-base font-bold text-gray-900 dark:text-white',
  p: 'text-base text-gray-600 dark:text-gray-300',
  span: 'text-base text-gray-600 dark:text-gray-300'
};

const Text: React.FC<TextProps> = ({ variant = 'p', className, children, ...props }) => {
  const Component = variant;
  const baseStyles = variantStyles[variant];

  return (
    <Component
      className={clsx(baseStyles, className)}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Text;